<div class="form-group">
  <div class="col-xs-12" *ngIf="isCheckBox">
    <label>
      <input type="checkbox" [(ngModel)]="response.Response" />
      <span *ngIf="!customField.Descr">{{ customField.FieldName }}</span>
      <span *ngIf="customField.Descr">{{ customField.Descr }}</span>
      <span *ngIf="customField.Amount > 0"> ({{ customField.Amount | currency }}) </span>
    </label>
  </div>
  <label class="col-xs-12" *ngIf="!isCheckBox">
    <span *ngIf="!customField.Descr">{{ customField.FieldName }}</span>
    <span *ngIf="customField.Descr">{{ customField.Descr }}</span>
  </label>
  <div class="col-xs-12">
    <select
      class="form-control"
      *ngIf="isDropDownList"
      [(ngModel)]="response.EventCustomRegFieldAvailValuesId"
      (ngModelChange)="onDropdownSelectedValueChange($event)"
    >
      <option [value]="0">Select one...</option>
      <option
        *ngFor="let fieldValue of customField?.AvailableValues"
        [value]="fieldValue.Id"
        [disabled]="
          fieldValue.UnitsAvailable > 0 &&
          fieldValue.UnitsAvailable <= fieldValue.UnitsTaken &&
          fieldValue.Id != response?.EventCustomRegFieldAvailValuesId
        "
        [text]="getAvailableValueOptionTextForDropdownType(fieldValue)"
      ></option>
    </select>
    <input class="form-control" type="text" *ngIf="isTextBox" [(ngModel)]="response.Response" />
    <input
      class="form-control"
      type="text"
      #numericInputNgModel="ngModel"
      [hidden]="!isInteger && !isDecimal"
      [(ngModel)]="response.Response"
      [pattern]="isDecimal ? '^\\d*(?:\\.\\d+)?$' : '^\\d*$'"
    />
    <div
      class="text-danger"
      *ngIf="isInteger || isDecimal"
      [hidden]="response.Response == null || response.Response == '' || numericInputNgModel?.valid"
    >
      <div [hidden]="!isInteger">{{ 'events.registration.shared.custom-field.integer-value-invalid' | translate }}</div>
      <div [hidden]="!isDecimal">{{ 'events.registration.shared.custom-field.decimal-value-invalid' | translate }}</div>
    </div>
    <textarea class="form-control" *ngIf="isTextArea" [(ngModel)]="response.Response"></textarea>
    <div *ngIf="hasItemsAvailable()">
      {{ 'events.registration.shared.custom-field.no-longer-available' | translate | titlecase }}
    </div>
  </div>
</div>
